import { AbstractControl, FormControl } from '@angular/forms';

export function equalTo(controller_name: string) {
  return (c: FormControl): { [key: string]: any } => {
    const e: AbstractControl | null = c.root.get(controller_name);
    if (e && c.value !== e.value) {
      const errors = { areEqual: false, ...e.errors };
      e.markAsDirty({ onlySelf: true });
      e.setErrors(errors);
      return {
        areEqual: false
      };
    }
    if (e) {
      if (e.errors) {
        delete e.errors[ 'areEqual' ];
        e.setErrors(JSON.stringify(e.errors) === '{}' ? null : e.errors);
      }
    }
    return null;
  };
}


export function lessOrEqualThen(controller_name: string) {
  return (c: FormControl): { [key: string]: any } => {
    const e: AbstractControl | null = c.root.get(controller_name);
    if (e && c) {
      const cv = parseFloat(c.value) || 0;
      const ev = parseFloat(e.value) || 0;
      if (cv > ev) {
        const errors = { ...e.errors, ...{ moreThen: false } };
        e.markAsDirty({ onlySelf: true });
        e.setErrors(errors);
        return {
          lessOrEqualThen: false
        };
      }
    }
    if (e) {
      if (e.errors) {
        delete e.errors[ 'moreThen' ];
        e.setErrors(JSON.stringify(e.errors) === '{}' ? null : e.errors);
      }
    }
    return null;
  };
}

export function moreThen(controller_name: string) {
  return (c: FormControl): { [key: string]: any } => {
    const e: AbstractControl | null = c.root.get(controller_name);
    if (e && c) {
      const cv = parseFloat(c.value) || 0;
      const ev = parseFloat(e.value) || 0;
      if (cv < ev) {
        const errors = { ...e.errors, ...{ lessOrEqualThen: false } };
        e.markAsDirty({ onlySelf: true });
        e.setErrors(errors);
        return {
          moreThen: false
        };
      }
    }
    if (e) {
      if (e.errors) {
        delete e.errors[ 'lessOrEqualThen' ];
        e.setErrors(JSON.stringify(e.errors) === '{}' ? null : e.errors);
      }
    }
    return null;
  };
}



// WEBPACK FOOTER //
// C:/projektyWeb/McComp_Flota/Front/src/app/core/validators.ts